export default {"src":"/_next/static/media/downhill_skiing.142b17b9.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};